var path = '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html';
var html = "<a target=_self href=\"{{ vm.href }}\" download=\"{{ vm.href }}\"><i class=\"fa fa-download\"></i> {{ vm.text }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/components/api_public_file_downloader/api_public_file_downloader.html
// module id = 1356
// module chunks = 0